import * as React from "react";

import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import Card from "@mui/material/Card";

import BottomNavigationAction from "@mui/material/BottomNavigationAction";

import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import DescriptionIcon from "@mui/icons-material/Description";
import ListIcon from "@mui/icons-material/List";

import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

import { BottomNavigation, Grid } from "@mui/material";

import SudList from "./SudList";
import SudPictures from "./SudPictures";
import SudMoreInfoList from "./SudMoreInfoList";
import SudFeatureList from "./SudFeatureList";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      style={{ height: "100%", overflowY: "auto" }}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function SudCard({ feature }) {
  const theme = useTheme();

  const properties = feature.properties;
  const {
    site_name: siteName,
    context,
    ref_no: referenceNumber,
    borough,
    delivery_year: deliveryYear,
    weblink,
    main_delivery_org: deliveryOrg,
    notes_public: notes,
    design_standard: designStandard,
    catchment_area: catchmentArea,
    storage_volume: storageVolume,
  } = properties;
  const imageKeys = Object.keys(properties).filter((key) =>
    key.includes("img")
  );
  const imageUrls = imageKeys.map((key) => properties[key]);

  const [value, setValue] = React.useState(0);

  return (
    <Card
      sx={{
        height: "365px",
        width: "580px",
        borderRadius: 0,
      }}
    >
      <Grid
        container
        sx={{
          height: "100%",
          maxHeight: "100%",
        }}
      >
        <Grid
          item
          xs={5}
          sx={{
            pl: 2,
            pr: 1,
            pt: 2,
            pb: 2,
            height: "100%",
            maxHeight: "100%",
          }}
        >
          <Typography component="div" variant="h5">
            {siteName}
          </Typography>
          <Typography
            variant="subtitle1"
            color="text.secondary"
            component="div"
            sx={{ borderBottom: `1px dotted #ffffff` }}
          >
            {context}
          </Typography>
          <SudList
            referenceNumber={referenceNumber}
            borough={borough}
            weblink={weblink}
            deliveryYear={deliveryYear}
            deliveryOrg={deliveryOrg}
          />
        </Grid>
        <Grid
          item
          xs={7}
          sx={{
            pr: 1,
            pt: 1,
            pl: 1,
            borderRadius: 0,
            display: "flex",
            flexDirection: "column",
            height: "100%",
            maxHeight: "100%",
            backgroundColor: theme.palette.background.secondary,
          }}
        >
          <TabPanel value={value} index={0}>
            <SudPictures imageUrls={imageUrls} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <SudFeatureList properties={properties} />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <SudMoreInfoList
              designStandard={designStandard}
              notes={notes}
              catchmentArea={catchmentArea}
              storageVolume={storageVolume}
            />
          </TabPanel>

          <BottomNavigation
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
            showLabels
            sx={{
              background: "inherit",
              backgroundImage: "inherit",
              borderTop: `1px solid ${theme.palette.primary.main}`,
            }}
          >
            <BottomNavigationAction
              label="Pictures"
              icon={<PhotoCameraIcon />}
            />

            <BottomNavigationAction label="Features" icon={<ListIcon />} />
            <BottomNavigationAction
              label="More info"
              icon={<DescriptionIcon />}
            />
          </BottomNavigation>
        </Grid>
      </Grid>
    </Card>
  );
}
